import { type FC } from 'react'

import { Text } from '@wartek-id/text-v1'

type DialogConsentProps = {
  children?: React.ReactNode
}

export const DialogConsent: FC<DialogConsentProps> = ({ children }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Text variant="display-sm">Lanjut dengan data ini?</Text>
        <Text color="subdued" className="!font-normal">
          Setelah lanjut, Anda dapat melanjutkan Penilaian Kinerja atau
          konfirmasi data ulang.
        </Text>
      </div>

      {children}
    </div>
  )
}
